import React from 'react';

const BookingBar = (props) => {
    const { rateDetails } = props
    return (
        <>
            <div className="book-bar padding-tb20 padding-lr20 margin-b20" style={{color: '#535354', fontSize: '14px', backgroundColor: '#f7f7f7'}}>
                <div className="row">
                    <div className="col-sm-4">
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total Green Fee:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {rateDetails.totalAmount}</strong> <small>(incl bucket and club)</small>
                            </div>
                        </div>
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total SGST 9%:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {rateDetails.totalSGST}</strong>
                            </div>
                        </div>
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total CGST 9%:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {rateDetails.totalCGST}</strong>
                            </div>
                        </div>
                        <div className="row margin-br5">
                            <div className="col-sm-4">
                                <strong className="margin-0">Total Amount:</strong>
                            </div>
                            <div className="col-sm-8">
                                <strong className="margin-0">₹ {rateDetails.finalAmount}</strong> <small>(incl GST)</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center padding-r50 padding-t20">
                        <strong>{rateDetails.fromDate} To {rateDetails.toDate}</strong>
                        <br />
                        <strong>{rateDetails.type}: {rateDetails.totalCancellation}</strong>
                        <br />
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookingBar;
